export default (processing, quantity, successful) => ({
    show: false,
    processing,
    quantity: quantity,
    successful: successful,
    incrementOrDecrementProcessing: false,
    debounce: null,
    historyPushed: false,

    init() {
        window.addEventListener('cart::mainEvent', ({ detail: [mainEvent] }) => {
            if (mainEvent.id) this.$wire.setCart(mainEvent.id);
        });

        window.addEventListener('popstate', this.handlePopState.bind(this));
    },

    open() {
        this.show = true;
    },

    added() {
        this.$store.cart.total += 1;
        this.close();
    },

    close() {
        if (this.processing || !this.show) {
            return;
        }

        if (this.successful) {
            return;
        }

        this.show = false;
        this.quantity = 1;
        this.incrementOrDecrementProcessing = false;
        this.$wire.call('resetOnClose');

        if (this.historyPushed) {
            history.back();
            this.historyPushed = false;
        }
    },

    dismiss() {
        this.successful = false;
        this.show = false;
        this.quantity = 1;
        this.incrementOrDecrementProcessing = false;
        this.$wire.call('resetOnClose');

        if (this.historyPushed) {
            history.back();
            this.historyPushed = false;
        }
    },

    handlePopState(event) {
        if (this.successful && this.show) {
            event.preventDefault();
            event.stopPropagation();

            if (!this.historyPushed) {
                history.pushState(null, '', window.location.href);
                this.historyPushed = true;
            }
        }
    },

    incrementQuantity() {
        if (this.processing || this.quantity >= 10) return;

        this.incrementOrDecrementProcessing = true;
        this.quantity++;

        clearTimeout(this.debounce);

        this.debounce = setTimeout(async () => {
            await this.$wire.set('quantity', this.quantity);
            this.incrementOrDecrementProcessing = false;
        }, 1000);
    },

    decrementQuantity() {
        if (this.processing || this.quantity <= 1) return;

        this.incrementOrDecrementProcessing = true;
        this.quantity--;

        clearTimeout(this.debounce);

        this.debounce = setTimeout(async () => {
            await this.$wire.set('quantity', this.quantity);
            this.incrementOrDecrementProcessing = false;
        }, 1000);
    },
});
